import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTab from 'eco-design/elements/eco-tab';
import EcoBundle1 from 'eco-design/sections/eco-bundle-1';
import { IPageStatus } from '@elem/compPage/portable-power-station-and-charger/config/IPageStatus';
import { useProductStore } from '@elem/compPage/portable-power-station-and-charger/ProductProvider';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useLang } from '@/i18n';
import { shopifyProductVariantSelectById } from '@/service';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.TabA1');
    const { locale } = useRouter();
    const { pageStatus } = useProductStore();

    const itemsA = [
        {
            tabValue: 'a1',
            tabLabel: t('item1_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744101920643/tab1_3.jpg',
        },
        {
            tabValue: 'a2',
            tabLabel: t('item2_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744101921108/tab1_2.jpg',
        },
        {
            tabValue: 'a3',
            tabLabel: t('item3_title'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744101920395/tab1_1.jpg',
        },
    ];
    const [activeItem, setActiveItem] = useState<any>(itemsA[0]);
    const [currentTabProducts, setCurrentTabProducts] = useState<any[]>([]);

    const productIds = {
        a1: [44331115479201, 51927572021615, 51836010660207],
        a2: [51641953616239, 51927572021615, 51836010660207],
        a3: [51835955872111, 51927572021615, 51841040286063],
    };

    // 如果 variantId ===

    const productDataMap = {
        itemsB1_a1: [
            {
                // pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                // title: `1.5kWh 走行充電セット`,
                subTitle: t('item1_bundle_subtitle1'),
                descItems: [t('item1_bundle_desc1_1'), t('item1_bundle_desc1_2')],
                // lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item1_bundle_button_1'),

                rChildren: t('item1_bundle_button_2'),
                lType: 'outlined',
                rType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                // price: 588,
                itemVariantId: 44331115479201,
                rDisabled: false,
            },
            {
                // pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                // title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item1_bundle_subtitle2'),
                descItems: [t('item1_bundle_desc2_1'), t('item1_bundle_desc2_2')],
                // lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item1_bundle_button_1'),

                lType: 'filled',
                rType: 'outlined',
                lTheme: 'blue',
                lRadius: 'ellipse',
                // price: 688,
                itemVariantId: 51927572021615,
                rDisabled: false,
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item1_bundle_subtitle3'),
                descItems: [t('item1_bundle_desc3_1'), t('item1_bundle_desc3_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item1_bundle_button_1'),

                lType: 'filled',
                rType: 'outlined',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 688,
                itemVariantId: 51836010660207,
                rDisabled: false,
            },
        ],
        itemsB1_a2: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `1.5kWh 走行充電セット`,
                subTitle: t('item2_bundle_subtitle1'),
                descItems: [t('item2_bundle_desc1_1'), t('item2_bundle_desc1_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item2_bundle_button_1'),
                rChildren: t('item2_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 588,
                itemVariantId: 51641953616239,
                rDisabled: false,
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item2_bundle_subtitle2'),
                descItems: [t('item2_bundle_desc2_1'), t('item2_bundle_desc2_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item2_bundle_button_1'),
                rChildren: t('item2_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 688,
                itemVariantId: 51927572021615,
                rDisabled: false,
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item2_bundle_subtitle3'),
                descItems: [t('item2_bundle_desc3_1'), t('item2_bundle_desc3_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item2_bundle_button_1'),
                rChildren: t('item2_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 688,
                itemVariantId: 51836010660207,
                rDisabled: false,
            },
        ],
        itemsB1_a3: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `1.5kWh 走行充電セット`,
                subTitle: t('item3_bundle_subtitle1'),
                descItems: [t('item3_bundle_desc1_1'), t('item3_bundle_desc1_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item3_bundle_button_1'),
                rChildren: t('item3_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 588,
                itemVariantId: 51835955872111,
                rDisabled: false,
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item3_bundle_subtitle2'),
                descItems: [t('item3_bundle_desc2_1'), t('item3_bundle_desc2_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item3_bundle_button_1'),
                rChildren: t('item3_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 688,
                itemVariantId: 51927572021615,
                rDisabled: false,
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1737361686313/sl_DP3.png',
                title: `ポータブルエアコン WAVE 3`,
                subTitle: t('item3_bundle_subtitle3'),
                descItems: [t('item3_bundle_desc3_1'), t('item3_bundle_desc3_2')],
                lHref: 'https://www.ecoflow.com/us/delta-pro-3-portable-power-station',
                lChildren: t('item3_bundle_button_1'),
                rChildren: t('item3_bundle_button_2'),

                lType: 'filled',
                lTheme: 'blue',
                lRadius: 'ellipse',
                price: 688,
                itemVariantId: 51841040286063,
                rDisabled: false,
            },
        ],
    };

    const onChangeA = (item: any) => {
        // const info = document.querySelector('.temp-section-3') as HTMLDivElement;
        // info.scrollIntoView({ behavior: 'smooth', block: 'start' });

        setActiveItem(item);
    };

    const queryShopifyProduct = async (variantIds: any) => {
        const shopifyRes = await shopifyProductVariantSelectById(locale, variantIds);

        if (shopifyRes?.code === '0') {
            if (shopifyRes?.data?.length > 0) {
                // const finalRes = shopifyRes?.data?.map((item: any, index: number) => {
                //     const currentTabItem = productDataMap[`itemsB1_${`${activeItem.tabValue}`}` as keyof typeof productDataMap];
                //     const matchedItem: any = currentTabItem.find((b) => `${b.itemVariantId}` === item.variantId);
                //     let rChildrenText = t('item1_bundle_button_4');
                //     let lChildrenText = matchedItem?.lChildren;
                //     if (`${variantIds[1]}` === item.variantId && pageStatus === IPageStatus.statusA) {
                //         rChildrenText = t('item1_bundle_button_3');
                //         lChildrenText = '';
                //     }
                //     if (`${variantIds[2]}` === item.variantId && (pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB)) {
                //         rChildrenText = t('item1_bundle_button_5');
                //         lChildrenText = '';
                //     }

                //     if (item?.inventoryQuantity && item?.inventoryQuantity > 0) {
                //         rChildrenText = t('item1_bundle_button_2');
                //     }

                //     return {
                //         ...matchedItem,
                //         ...item,
                //         pc: item?.img,
                //         title: item?.productTitle,
                //         lChildren: lChildrenText,
                //         rChildren: rChildrenText,
                //         lHref: `https://${locale}.ecoflow.com/products/${item?.handle}`,
                //         rHref: `https://${locale}.ecoflow.com/cart/${item?.variantId}:1?channel=buy_button`,
                //         lDataLayer: {
                //             event: 'uaEvent',
                //             event_name: 'buy',
                //             product_name: item?.productTitle,
                //             position: 'Product Detail',
                //         },
                //         rDataLayer: {
                //             event: 'uaEvent',
                //             event_name: 'checkout',
                //             button_name: rChildrenText,
                //         },
                //     };
                // });

                const currentTabItem = productDataMap[`itemsB1_${`${activeItem.tabValue}`}` as keyof typeof productDataMap];
                const finalRes = currentTabItem?.map((item: any, index: number) => {
                    // const finalRes = shopifyRes?.data?.map((item: any, index: number) => {
                    const matchedItem: any = shopifyRes?.data?.find((b: any) => b.variantId === `${item.itemVariantId}`);
                    let rChildrenText = t('item1_bundle_button_4');
                    let lChildrenText = item?.lChildren;

                    if (matchedItem?.inventoryQuantity && matchedItem?.inventoryQuantity > 0) {
                        rChildrenText = t('item1_bundle_button_2');
                    }

                    if (`${variantIds[1]}` === matchedItem?.variantId && pageStatus === IPageStatus.statusA) {
                        rChildrenText = t('item1_bundle_button_3');
                        lChildrenText = '';
                        matchedItem.rDisabled = true;
                    }

                    // TODO: 需要业务确定冰箱上线时间后再处理按钮显示逻辑
                    if (`${variantIds[2]}` === matchedItem?.variantId && pageStatus !== IPageStatus.statusC) {
                        rChildrenText = t('item1_bundle_button_5');
                        lChildrenText = '';
                        matchedItem.rDisabled = true;
                    }

                    // if (`${variantIds[2]}` === matchedItem?.variantId && (pageStatus === IPageStatus.statusA || pageStatus === IPageStatus.statusB)) {
                    //     rChildrenText = t('item1_bundle_button_5');
                    //     lChildrenText = '';
                    //     matchedItem.rDisabled = true;
                    // }

                    const finalTitle = matchedItem?.skuTitle && matchedItem?.skuTitle !== 'Default Title' ? matchedItem?.skuTitle : matchedItem?.productTitle;

                    const isWave3 = `${variantIds[1]}` === matchedItem?.variantId && (pageStatus === IPageStatus.statusB || pageStatus === IPageStatus.statusC);

                    const isGlacier2 = `${variantIds[2]}` === matchedItem?.variantId && pageStatus === IPageStatus.statusC;

                    return {
                        ...item,
                        ...matchedItem,
                        pc: matchedItem?.img,
                        // title: matchedItem?.productTitle,
                        title: finalTitle,
                        lChildren: lChildrenText,
                        rChildren: rChildrenText,
                        lHref: !!isWave3
                            ? `https://www.ecoflow.com/${locale}/wave-3-portable-air-conditioner`
                            : !!isGlacier2
                            ? `https://www.ecoflow.com/${locale}/glacier-classic-portable-refrigerator`
                            : `https://${locale}.ecoflow.com/products/${matchedItem?.handle}`,
                        rHref: `https://${locale}.ecoflow.com/cart/${matchedItem?.variantId}:1?channel=buy_button`,
                        lDataLayer: {
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: finalTitle,
                            position: 'Product Detail',
                        },
                        rDataLayer: {
                            event: 'uaEvent',
                            event_name: 'checkout',
                            button_name: `${rChildrenText}_${finalTitle}`,
                        },
                    };
                });
                setCurrentTabProducts(finalRes);
            }
        }
    };

    useEffect(() => {
        const variantIds = productIds[activeItem.tabValue as keyof typeof productIds];
        queryShopifyProduct(variantIds);
    }, [activeItem.tabValue]);

    return (
        <div className={`temp-section-3 ${styles.comp}`} id="section-3">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} theme="white" />
            <EcoTab className="temp-section-3-box" items={itemsA} theme="black" onChange={onChangeA} type="square" />
            <EcoSpaceSmall />
            <div className="eco-content page-TabA1-img">
                <EcoImgVideo pc={activeItem.pc} />
            </div>
            <EcoSpaceSmall />
            <EcoBundle1 items={currentTabProducts} layout="spread" />
        </div>
    );
}
